import { Box } from '@dtx-company/shared-components/src/components/atoms/Box/index'
import { FC } from 'react'
import { Text } from '@dtx-company/shared-components/src/components/atoms/Text/index'
import { TextStyleProps } from '@dtx-company/shared-components/src'

export const TruncatedText: FC<TextStyleProps> = ({ children, ...rest }) => (
  <Box width="100%" display="table" style={{ tableLayout: 'fixed' }}>
    <Text
      {...rest}
      display="table-cell"
      style={{ whiteSpace: 'nowrap', textOverflow: 'ellipsis', overflow: 'hidden' }}
      fontSize="inherit !important;"
    >
      {children}
    </Text>
  </Box>
)
